function toMoney(amount?: number, options: Intl.NumberFormatOptions = {}) {
  const value = amount || 0;
  return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR', ...options });
}

export default toMoney;
